import i18n from '../i18n';

// 将日期字符串转换为时间戳（毫秒）
export function dateStringToTimestamp(dateString) {
    return new Date(dateString).getTime();
  }

  // 将时间戳（毫秒）转换为日期字符串（YYYY-MM-DDTHH:mm 格式，用于datetime-local输入）
  export function timestampToDateString(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    return `${year}-${month}-${day}T${hour}:${minute}`;
  }

  // 格式化时间显示（根据当前语言环境）
  export function formatDateTime(timestamp) {
    if (!timestamp) {
      return i18n.t('dateTime.invalidDate', '无效日期');
    }
    try {
      const date = new Date(timestamp);
      // 检查日期是否有效
      if (isNaN(date.getTime())) {
        return i18n.t('dateTime.invalidDate', '无效日期');
      }

      // 获取当前语言
      const currentLang = i18n.language || 'zh-CN';

      // 使用 Intl.DateTimeFormat 进行本地化格式化
      const formatter = new Intl.DateTimeFormat(currentLang, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });

      return formatter.format(date);
    } catch (error) {
      console.error("Error formatting date:", error);
      return i18n.t('dateTime.formatError', '日期格式错误');
    }
  }

  // 格式化时间用于复制（YYYY-MM-DD HH:mm 格式）
  export function formatDateTimeForCopy(timestamp) {
    if (!timestamp) {
      return "无效日期";
    }
    try {
      const date = new Date(timestamp);
      // 检查日期是否有效
      if (isNaN(date.getTime())) {
        return "无效日期";
      }
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "日期格式错误";
    }
  }

  // 格式化天数，最小0.1天，不足0.1的记录为0.1
  export function formatDaysWithMinimum(hours) {
    const days = hours / 8;
    if (days <= 0) {
      return '0.0';
    }
    if (days < 0.1) {
      return '0.1';
    }
    return days.toFixed(1);
  }
  
  // 计算工作时间
  export function calculateWorkingHours(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);

    // 验证日期是否有效
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      console.error('Invalid date provided:', { startTime, endTime });
      return 0;
    }

    let totalHours = 0;
    let currentDay = new Date(start);

    while (currentDay < end) {
      const dayEnd = new Date(currentDay);
      dayEnd.setHours(18, 30, 0, 0);  // 设置当天最晚下班时间为18:30

      const dayStart = new Date(currentDay);
      dayStart.setHours(9, 0, 0, 0);  // 设置当天最早上班时间为9:00

      // 调整实际开始和结束时间
      const effectiveStart = new Date(Math.max(currentDay, dayStart));
      const effectiveEnd = new Date(Math.min(end, dayEnd));

      let dayHours = (effectiveEnd - effectiveStart) / (1000 * 3600);

      // 处理午休时间
      const lunchStart = new Date(currentDay);
      lunchStart.setHours(12, 0, 0, 0);
      const lunchEnd = new Date(currentDay);
      lunchEnd.setHours(13, 0, 0, 0);

      if (effectiveStart < lunchEnd && effectiveEnd > lunchStart) {
        dayHours -= 1; // 减去1小时午休时间
      }

      // 如果工作时间在 8 小时到 9 小时之间（包括午休），则视为标准 8 小时工作日
      if (dayHours >= 8 && dayHours <= 9) {
        dayHours = 8;
      } else if (dayHours > 9) {
        // 如果工作时间超过 9 小时，按实际时间计算，但不超过 11 小时
        dayHours = Math.min(dayHours, 11);
      }

      totalHours += dayHours;

      currentDay.setDate(currentDay.getDate() + 1);
      currentDay.setHours(9, 0, 0, 0);  // 设置下一天的最早开始时间为9:00
    }

    return totalHours;
  }
  
  // 计算加班时间
  export function calculateOvertimeHours(startTime, endTime) {
    const start = new Date(startTime);
    const end = new Date(endTime);

    // 验证日期是否有效
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      console.error('Invalid date provided:', { startTime, endTime });
      return 0;
    }

    // 计算总时间（毫秒）
    let totalMilliseconds = end.getTime() - start.getTime();

    // 将总时间转换为小时
    let totalHours = totalMilliseconds / (1000 * 60 * 60);

    return Math.max(totalHours, 0); // 确保返回值不小于0
  }